export const COMPANY = {
  legalName: "JobTeen Sàrl-S",
  legalForm: "Société à responsabilité limitée simplifiée (Sàrl-S)",
  streetAddress: "3 Bei der Kirelheck",
  postalCode: "L-5652",
  locality: "Mondorf-les-Bains",
  country: "Grand-Duché de Luxembourg",
  countryCode: "LU",
  email: "jobteenservice@gmail.com",
  website: "https://jobteen.app",
  establishmentPermit: "10193224 / 0",
} as const;